import React from "react";
import { Breadcrumb } from "./styles"

export default props => {
    return (
        <Breadcrumb separator=">">
            <Breadcrumb.Item><a href="gestao-acessos">Gestão de acessos</a></Breadcrumb.Item>
            <Breadcrumb.Item>{ props.company_name }</Breadcrumb.Item>
            {props.user ? <Breadcrumb.Item>{ 'Usuários' }</Breadcrumb.Item> : ''}
        </Breadcrumb>
    )
}